import { useState } from "react";

const fmt = (d) => (d ? new Date(d.length === 10 ? `${d}T12:00:00` : d).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "—");
const fmtTs = (d) => (d ? new Date(d).toLocaleString() : "—");
const STATUS_CLASS = { APPLIED: "text-sage", FLAGGED: "text-amber-700", IGNORED: "text-warmgrey" };

const auditLine = (a) => {
  const ov = (v) => (v && typeof v === "object" ? JSON.stringify(v) : String(v ?? "—"));
  return `${a.type.replace(/^container_/, "").replace(/_/g, " ")} · ${a.key}: ${ov(a.old_value)} → ${ov(a.new_value)}${a.note ? ` · ${a.note}` : ""}`;
};

export const TrackingEvents = ({ events, audit }) => {
  const [tab, setTab] = useState("events");
  return (
    <div className="mt-8" data-testid="tracking-history">
      <div className="flex gap-4 border-b border-border">
        {[["events", `Tracking events (${events.length})`], ["audit", `Logistics audit (${audit.length})`]].map(([k, l]) => (
          <button key={k} type="button" onClick={() => setTab(k)} data-testid={`tracking-tab-${k}`} className={`-mb-px border-b-2 pb-2 text-xs font-semibold uppercase tracking-wider transition-colors ${tab === k ? "border-terracotta text-charcoal" : "border-transparent text-warmgrey hover:text-charcoal"}`}>{l}</button>
        ))}
      </div>
      {tab === "events" ? (
        events.length === 0 ? <p className="py-6 text-sm text-warmgrey" data-testid="tracking-events-empty">No tracking events recorded yet. Record a stage manually or import the broker's update file.</p> : (
          <ul className="divide-y divide-border">
            {events.map((e) => (
              <li key={e.id} className="flex flex-wrap items-start justify-between gap-2 py-3" data-testid={`tracking-event-${e.id}`}>
                <div className="min-w-0">
                  <p className="text-sm text-charcoal">
                    <span className="font-medium">{e.event_type.replace(/_/g, " ")}</span> · {fmt(e.event_time)}
                    {(e.times?.event || e.times?.eta) && <span className="text-warmgrey" title={`UTC ${(e.times.event || e.times.eta).utc} · carrier original ${(e.times.event || e.times.eta).original}`} data-testid={`tracking-event-local-${e.id}`}> · {(e.times.event || e.times.eta).display}</span>}
                    {e.event_kind && <span className={`ml-1 rounded px-1 text-[10px] font-semibold uppercase ${e.event_kind === "ESTIMATE" ? "bg-amber-100 text-amber-900" : "bg-sage/15 text-sage"}`}>{e.event_kind === "ESTIMATE" ? "estimated" : "actual"}</span>}
                    {e.location && <span className="text-warmgrey"> · {e.location}</span>}
                    {e.eta && <span className="text-warmgrey"> · ETA {fmt(e.eta)}</span>}
                    {e.vessel && <span className="text-warmgrey"> · {e.vessel}{e.voyage ? ` / ${e.voyage}` : ""}</span>}
                  </p>
                  <p className="mt-0.5 text-xs text-warmgrey">
                    Source {e.source} · recorded {fmtTs(e.ingested_at)}{e.late_historical ? " · late historical (stage not regressed)" : ""}{e.note ? ` · ${e.note}` : ""}
                  </p>
                  {e.flags?.length > 0 && <p className="mt-0.5 text-xs text-amber-800">{e.flags.map((f) => f.message).join(" · ")}</p>}
                </div>
                <span className={`text-[11px] font-semibold uppercase tracking-wider ${STATUS_CLASS[e.status] || ""}`} data-testid={`tracking-event-status-${e.id}`}>{e.status}</span>
              </li>
            ))}
          </ul>
        )
      ) : (
        audit.length === 0 ? <p className="py-6 text-sm text-warmgrey">No logistics audit rows yet.</p> : (
          <ul className="divide-y divide-border">
            {audit.map((a) => (
              <li key={a.id} className="py-3" data-testid={`tracking-audit-${a.id}`}>
                <p className="break-words text-xs text-charcoal">{auditLine(a)}</p>
                <p className="mt-0.5 text-[11px] text-warmgrey">{fmtTs(a.at)} · {a.actor}</p>
              </li>
            ))}
          </ul>
        )
      )}
    </div>
  );
};
